import { useEffect, useState } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

import { ROUTES } from 'consts';

// todo
// надо?
export const useSelected = () => {
  const [selected, setSelected] = useState('/');

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    // console.log('path', path);
    // console.log('1', countOccurrences(path, '/'));

    if (countOccurrences(path, '/') > 1) {
      path && setSelected(path);
    } else {
      setSelected(path);
    }
  }, [location.pathname]);

  // TODO
  const isSheduleTransferDetails = matchPath(selected, {
    path: ROUTES.DELIVERY_SCHEDULE.DETAILS_TABLE_ID,
  });
  if (isSheduleTransferDetails) {
    setSelected(ROUTES.DELIVERY_SCHEDULE.ROOT);
  }

  return [selected];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const countOccurrences = (text: any, search: any) =>
  (text.match(new RegExp(search, 'g')) || []).length;
// console.log(countOccurrences('яблоко банан яблоко', 'яблоко')); // Результат: 2
